import { render } from "./VModalSlot.vue?vue&type=template&id=0d073c94"
import script from "./VModalSlot.vue?vue&type=script&lang=js"
export * from "./VModalSlot.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__